import React from 'react';
import {
    Link
} from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar';
import {
    Container,
    Title,
    Description,
    Content,
    NewLine,
    Point
} from './style';

class FAQ extends React.Component {
    state = {
        loadingBarProgress: Math.random() * 100
    };

    complete = () => {
        this.setState({ loadingBarProgress: 100 });
    };

    onLoaderFinished = () => {
        this.setState({ loadingBarProgress: 0 });
    };

    componentDidMount() {
        this.complete();
    }

    render() {
        return (
            <Container>
                <LoadingBar
                    progress={this.state.loadingBarProgress}
                    height={3}
                    color='#fff'
                    onLoaderFinished={() => this.onLoaderFinished()}
                />
                <Link to="/"><Title> {"{"} nightbot.dev {"}"} </Title></Link>
                <Description><Point> Frequently Asked Questions </Point></Description>
                <Content>
                    
                    <Point>What service are you offering?</Point>
                    <NewLine />
                    I offer chatbot development service, but I can also provide you with article writing service in the related fields (Chatbot, Artificial Intelligence, Data Mining, and Machine Learning—and how it will improve your clients' business) if you need it
                    <NewLine />
                    <NewLine />
                    
                    <Point>I have a dream chatbot, can you help me to make it come true?</Point>
                    <NewLine />
                    Yes, just contact me to see my availability
                    <NewLine />
                    <NewLine />

                    <Point>Can I see another project demos?</Point>
                    <NewLine />
                    I will add new project demos in the future, make sure to regularly check this site
                    <NewLine />
                    <NewLine />

                    <Point>How do I contact you?</Point>
                    <NewLine />
                    If you have any question or just want to say hi, drop me a message: dikyhd ^gmail
                    <NewLine />
                    Or click the links on the bottom of the page
                </Content>
            </Container>
        )
    }
}

export default FAQ;